import { Component, Input, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common'; 

@Component({
  selector: 'leader-profile',
  standalone: true,
  imports: [
    CommonModule 
  ],
  templateUrl: './leader-profile.component.html',
  styleUrl: './leader-profile.component.css'
})
export class LeaderProfileComponent implements OnInit {
  
  activeTab: string = 'posts'; // Default tab is "Posts"
  
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
  
  @Input() data: any = {
    
    data: [
      {
      name: "Swapnil Patil",
      type: "Leader",
      profilePicture: "https://images.pexels.com/photos/326055/pexels-photo-326055.jpeg?auto=compress&cs=tinysrgb&w=600",
      mobile: "+917055223388",
      email: "adarshovhal11@gmail.com",
      address: {
        location: "Kalewadi, Pune",
      }
    }
    ]
  };

  @Input() config: any = { 
      config: {
    wrapperClass: 'wrapper',
    containerClass: 'container mt-4',
    rowClass: 'row news-card shadow-lg p-3 bg-white rounded',
    leftImageClass: 'col-lg-4 d-none d-lg-block',
    imageClass: 'news-image img-fluid rounded',
    cardClass: 'col-lg-8 col-12',
    authorClass: 'd-flex align-items-center mb-2',
    profileClass: 'profile-img me-2 img-fluid rounded-circle w-25 h-25 object-fit-cover',
    profileButtonClass: 'btn',
    textClass: 'text-muted fw-bold mb-1',
    dateClass: 'text-muted small mb-0',
    statusButtonClass: 'btn btn-outline-secondary btn-sm ms-auto share-btn',
    shareButtonClass: 'btn btn-outline-warning btn-sm ms-2',
    mobileImageClass: 'd-lg-none text-center mb-3',
    titleClass: 'fw-bold',
    descriptionClass: 'text-muted',
    tagsClass: 'mb-2',
    badgeClass: 'badge text-black me-1',
    reactionClass: 'd-flex align-items-center mb-2',
    likeButtonClass: 'btn btn-light btn-sm me-2',
    dislikeButtonClass: 'btn btn-light btn-sm me-2',
    commentButtonClass: 'btn btn-light btn-sm',
    modalClass: 'modal fade',
    modalDialogClass: 'modal-dialog modal-dialog-centered modal-lg',
    modalContentClass: 'modal-content',
    modalBodyClass: 'modal-body text-center',
    modalImageClass: 'img-fluid rounded',
    modalFooterClass: 'modal-footer',
    closeButtonClass: 'btn btn-primary',
    useIcons: true,
    profileDetailsClass: 'd-flex flex-column',
      }
  };
  
  selectedImage: string = '';
  
  openModal(image: string) {
    this.selectedImage = image;
  }  

  ngOnInit(): void {
    console.log ("Leader-Profile :", this.data)
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    if (typeof this.config === 'string') {
      this.config = JSON.parse(this.config);
    }
  }

  defaultProfileImage: string = 'https://gratisography.com/wp-content/uploads/2024/11/gratisography-augmented-reality-800x525.jpg';

}
